// ตัวเลือกคงที่ของระบบ "กินอะไรดี" (ค่า value ต้องตรงกับ DTO ของ backend) + ข้อมูลจำลองของหน้าที่ยังไม่ทำ API (Pantry / Nearby)

export const eatingModes = [
  { key: "lose", emoji: "🥗", label: "ลดน้ำหนัก", hint: "แคลต่ำ อิ่มด้วยผักและโปรตีน" },
  { key: "protein", emoji: "💪", label: "เพิ่มโปรตีน", hint: "โปรตีน 30 g ขึ้นไปต่อมื้อ" },
  { key: "full", emoji: "⚡", label: "อิ่มนาน", hint: "ไฟเบอร์สูง ย่อยช้า" },
  { key: "save", emoji: "💰", label: "ประหยัด", hint: "ไม่เกิน 60 บาทต่อมื้อ" },
  { key: "free", emoji: "😋", label: "ตามใจตัวเอง", hint: "วันนี้ไม่คิดเรื่องแคล" },
  { key: "preworkout", emoji: "🏃", label: "ก่อนออกกำลัง", hint: "คาร์บย่อยง่าย ไม่หนักท้อง" },
  { key: "late", emoji: "💤", label: "มื้อดึก", hint: "เบา ๆ ไม่รบกวนการนอน" },
  { key: "cook", emoji: "🍳", label: "ทำเอง", hint: "ใช้ของที่มีในตู้เย็น" },
  { key: "delivery", emoji: "🛵", label: "สั่ง Delivery", hint: "ร้านที่ส่งถึงใน 30 นาที" },
];

export const mealSlots = [
  { key: "breakfast", label: "มื้อเช้า", icon: "fa-solid fa-sun", time: "08:00" },
  { key: "lunch", label: "มื้อกลางวัน", icon: "fa-solid fa-utensils", time: "12:00" },
  { key: "snack", label: "ของว่าง", icon: "fa-solid fa-cookie-bite", time: "15:30" },
  { key: "dinner", label: "มื้อเย็น", icon: "fa-solid fa-moon", time: "18:00" },
  { key: "late", label: "มื้อดึก", icon: "fa-solid fa-bed", time: "21:00" },
];

export const goalOptions = [
  { value: "lose", label: "ลดน้ำหนัก" },
  { value: "maintain", label: "รักษาน้ำหนัก" },
  { value: "gain", label: "เพิ่มกล้ามเนื้อ" },
  { value: "health", label: "สุขภาพทั่วไป" },
];
export const genderOptions = [
  { value: "male", label: "ชาย" },
  { value: "female", label: "หญิง" },
  { value: "other", label: "ไม่ระบุ" },
];
export const activityOptions = [
  { value: "0", label: "ไม่ออกกำลังกาย" },
  { value: "1", label: "1-2 วัน/สัปดาห์" },
  { value: "3", label: "3-4 วัน/สัปดาห์" },
  { value: "5", label: "5 วันขึ้นไป/สัปดาห์" },
];
export const locationOptions = [
  { value: "home", label: "บ้าน" },
  { value: "office", label: "ที่ทำงาน" },
  { value: "campus", label: "มหาวิทยาลัย" },
];
export const purchaseOptions = [
  { value: "cook", label: "ทำเอง", icon: "fa-solid fa-kitchen-set" },
  { value: "buy", label: "ร้านอาหาร", icon: "fa-solid fa-store" },
  { value: "delivery", label: "Delivery", icon: "fa-solid fa-motorcycle" },
];
export const groupOptions = [
  { value: "rice", label: "🍚 ข้าว" },
  { value: "noodle", label: "🍜 เส้น" },
  { value: "meat", label: "🥩 เนื้อ" },
  { value: "light", label: "🥗 เบา ๆ" },
  { value: "snack", label: "🍌 ของว่าง" },
  { value: "drink", label: "🥤 เครื่องดื่ม" },
];
export const sourceOptions = [
  { value: "home", label: "ทำเอง" },
  { value: "restaurant", label: "ร้านอาหาร" },
  { value: "delivery", label: "Delivery" },
];
// แท็กมาตรฐานที่ engine ใช้ให้คะแนน (เพิ่มแท็กอื่นได้ แต่แท็กเหล่านี้มีผลกับการแนะนำ)
export const knownTags = ["โปรตีนสูง", "คุมแคล", "อิ่มนาน", "ประหยัด", "รสจัด", "ไม่หนักท้อง", "มื้อดึก", "มื้อเช้า", "ก่อนออกกำลัง", "คาร์บย่อยง่าย", "ตามใจตัวเอง", "ทำเอง", "ผักเยอะ", "คลีน", "ไขมันดี", "ทอด", "หวาน"];

// คำถาม 3 ข้อของ AI Meal Decision (value ตรงกับ DecideDto)
export const decisionQuestions = [
  {
    key: "hunger", title: "ตอนนี้หิวแค่ไหน?", hint: "ใช้กะขนาดมื้อและพลังงานที่เหมาะ",
    options: [
      { value: "low", emoji: "😐", label: "ไม่มาก", hint: "ของว่างหรือมื้อเล็ก" },
      { value: "mid", emoji: "🙂", label: "ปานกลาง", hint: "มื้อปกติ 400-600 kcal" },
      { value: "high", emoji: "🤤", label: "มาก", hint: "มื้อใหญ่ อิ่มนาน" },
    ],
  },
  {
    key: "craving", title: "อยากกินอะไร?", hint: "ไม่รู้ก็ได้ AI จะดูจากประวัติให้",
    options: [
      { value: "rice", emoji: "🍚", label: "ข้าว" },
      { value: "noodle", emoji: "🍜", label: "เส้น" },
      { value: "meat", emoji: "🥩", label: "เนื้อ" },
      { value: "light", emoji: "🥗", label: "เบา ๆ" },
      { value: "any", emoji: "🤷", label: "ไม่รู้" },
    ],
  },
  {
    key: "budget", title: "งบเท่าไหร่?", hint: "ยึดตามงบต่อมื้อในโปรไฟล์ได้",
    options: [
      { value: "50-100", emoji: "💵", label: "฿50–100" },
      { value: "100-200", emoji: "💰", label: "฿100–200" },
      { value: "200+", emoji: "💎", label: "฿200+" },
    ],
  },
];

// ---------- ข้อมูลจำลองของหน้าที่ยังไม่ทำ API (ข้อ 11-12) ----------
export const pantryDefaults = ["ไข่", "อกไก่", "แครอท", "ผักสลัด", "ข้าว", "แซลมอน"];
export const pantrySuggestions = ["หอมใหญ่", "กระเทียม", "มะเขือเทศ", "เต้าหู้", "เห็ด", "บรอกโคลี", "นม", "ขนมปัง", "หมูสับ", "พริก"];

export const recipes = [
  {
    id: 1, rank: 1, name: "ข้าวหน้าไก่ย่าง", emoji: "🍗", kcal: 520, protein: 40, minutes: 25, uses: ["อกไก่", "ข้าว", "แครอท"],
    steps: ["หมักอกไก่กับซีอิ๊ว กระเทียม พริกไทย 10 นาที", "ย่างหรืออบ 180°C ประมาณ 15 นาที", "หั่นวางบนข้าว โรยแครอทซอย ราดน้ำจิ้มแจ่ว"],
  },
  {
    id: 2, rank: 2, name: "สลัดไก่ + ไข่", emoji: "🥗", kcal: 420, protein: 38, minutes: 15, uses: ["อกไก่", "ไข่", "ผักสลัด", "แครอท"],
    steps: ["ต้มไข่ 7 นาที ผ่าครึ่ง", "ย่างอกไก่ หั่นเป็นชิ้น", "จัดผักสลัด แครอท ไก่ และไข่ ราดน้ำสลัดงา"],
  },
  {
    id: 3, rank: 3, name: "แซลมอนย่าง + ผัก", emoji: "🍣", kcal: 480, protein: 36, minutes: 20, uses: ["แซลมอน", "ผักสลัด", "แครอท"],
    steps: ["โรยเกลือ พริกไทย บนแซลมอน", "ย่างด้านหนังก่อน 4 นาที กลับด้าน 3 นาที", "เสิร์ฟกับผักสลัดและแครอทต้ม บีบมะนาว"],
  },
];

export const restaurants = [
  { id: 1, name: "ร้านครัวคุณแม่", distance: 350, minutes: 5, rating: 4.6, emoji: "🍗", menu: "ข้าวไก่ย่าง", kcal: "500–600", protein: "สูง", price: 69, tags: ["โปรตีนสูง", "ในงบ"], picked: true, open: true },
  { id: 2, name: "Salad Story", distance: 600, minutes: 8, rating: 4.4, emoji: "🥗", menu: "สลัดอกไก่", kcal: "350–450", protein: "สูง", price: 89, tags: ["คุมแคล"], picked: false, open: true },
  { id: 3, name: "เตี๋ยวเรือลุงหนวด", distance: 200, minutes: 3, rating: 4.2, emoji: "🍜", menu: "ก๋วยเตี๋ยวน้ำตก", kcal: "400–500", protein: "ปานกลาง", price: 55, tags: ["ประหยัด", "ไม่หนักท้อง"], picked: false, open: true },
  { id: 4, name: "Sushi Hana", distance: 1200, minutes: 15, rating: 4.7, emoji: "🍣", menu: "ข้าวหน้าปลาแซลมอน", kcal: "500–600", protein: "สูง", price: 149, tags: ["โปรตีนสูง"], picked: false, open: false },
  { id: 5, name: "ตำแซ่บ", distance: 450, minutes: 6, rating: 4.3, emoji: "🌶️", menu: "ส้มตำไทย + ไก่ย่าง", kcal: "450–550", protein: "สูง", price: 95, tags: ["รสจัด"], picked: false, open: true },
];
